"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AppState = _interopRequireDefault(require("composer-lib/data/model/AppState"));

var _draftHelpers = require("composer-plugins/lib/draftHelpers");

var _conversations = require("composer-lib/redux/actions/conversations");

var _Composition = _interopRequireDefault(require("composer-lib/data/model/Composition"));

var _Conversations = _interopRequireDefault(require("composer-lib/data/model/Conversations"));

var _ConversationsWrapper = _interopRequireDefault(require("composer-lib/components/comments/ConversationsWrapper"));

var _reactRedux = require("react-redux");

var _comments = require("composer-lib/redux/actions/comments");

var _draftJs = require("draft-js");

var _highlightHelpers = require("composer-lib/lib/helpers/highlightHelpers");

var _conversationsHelpers = require("composer-lib/lib/helpers/conversationsHelpers");

var _editor = require("composer-lib/redux/actions/editor");

var _composer = require("composer-lib/redux/actions/composer");

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _users = require("composer-lib/redux/actions/users");

var _constants = require("composer-lib/lib/constants");

var _SaveState = _interopRequireDefault(require("composer-lib/data/model/SaveState"));

var _immutable = require("immutable");

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIAbstractFloaty = _interopRequireDefault(require("UIComponents/tooltip/UIAbstractFloaty"));

var _Users = _interopRequireDefault(require("composer-lib/data/model/Users"));

var computeFloatyPosition = (0, _conversationsHelpers.getComputeFloatyPosition)();

var mapStateToProps = function mapStateToProps(state) {
  return {
    composition: state.composition,
    saveState: state.save,
    conversations: state.conversations,
    auth: state.auth,
    app: state.app,
    users: state.users
  };
};

var mapDispatchToProps = {
  closeConversations: _conversations.closeConversations,
  createConversationAndInitialComment: _comments.createConversationAndInitialComment,
  createDummyConversation: _conversations.createDummyConversation,
  deleteComment: _comments.deleteComment,
  deleteConversation: _conversations.deleteConversation,
  deleteConversationDone: _conversations.deleteConversationDone,
  highlightBodyText: _editor.highlightBodyText,
  highlightSummaryText: _editor.highlightSummaryText,
  highlightTitleText: _editor.highlightTitleText,
  refetchUsers: _users.refetchUsers,
  removeHighlightedBodyText: _editor.removeHighlightedBodyText,
  removeHighlightedSummaryText: _editor.removeHighlightedSummaryText,
  removeHighlightedTitleText: _editor.removeHighlightedTitleText,
  openConversation: _conversations.openConversation,
  saveComment: _comments.saveComment,
  selectConversationBlock: _conversations.selectConversationBlock,
  updateContentToSave: _composer.updateContentToSave,
  updateTitleToSave: _composer.updateTitleToSave
};
var CommentsContainer = (0, _createReactClass.default)({
  displayName: "CommentsContainer",
  propTypes: {
    app: _propTypes.default.instanceOf(_AppState.default).isRequired,
    auth: _propTypes.default.object.isRequired,
    closeConversations: _propTypes.default.func,
    composition: _propTypes.default.instanceOf(_Composition.default).isRequired,
    conversations: _propTypes.default.instanceOf(_Conversations.default).isRequired,
    createConversationAndInitialComment: _propTypes.default.func,
    createDummyConversation: _propTypes.default.func.isRequired,
    deleteComment: _propTypes.default.func,
    deleteConversation: _propTypes.default.func,
    deleteConversationDone: _propTypes.default.func,
    highlightBodyText: _propTypes.default.func,
    highlightSummaryText: _propTypes.default.func,
    highlightTitleText: _propTypes.default.func,
    selectConversationBlock: _propTypes.default.func,
    openConversation: _propTypes.default.func,
    refetchUsers: _propTypes.default.func,
    removeHighlightedBodyText: _propTypes.default.func,
    removeHighlightedSummaryText: _propTypes.default.func,
    removeHighlightedTitleText: _propTypes.default.func,
    saveComment: _propTypes.default.func,
    saveState: _propTypes.default.instanceOf(_SaveState.default).isRequired,
    users: _propTypes.default.instanceOf(_Users.default).isRequired,
    updateContentToSave: _propTypes.default.func.isRequired
  },
  contextTypes: {
    gates: _propTypes.default.instanceOf(_immutable.Set)
  },
  saveComment: function saveComment(message, index, conversation) {
    if (message) {
      var conversationId = (0, _conversationsHelpers.getRealConversationId)(this.props.conversations.dummyConversations, conversation.id); // Need to create conversation and then comment

      if (conversation.isEmptyDummy) {
        this.props.createConversationAndInitialComment(message, index, this.props.composition.id, _PortalIdParser.default.get(), this.props.auth.user.get('user_id'), this.props.conversations.blockMap.get(index).get(conversationId));
      } else {
        this.props.saveComment(message, index, this.props.composition.id, _PortalIdParser.default.get(), this.props.auth.user.get('user_id'), conversationId);
      }
    }
  },
  findConversationWithSameTopic: function findConversationWithSameTopic(correlationId, highlightText, highlightStart, highlightEnd) {
    var conversationsBlock = this.props.conversations.blockMap.get(correlationId);

    if (conversationsBlock) {
      var sameConversation = conversationsBlock.find(function (c) {
        return c.highlightText === highlightText && c.highlightStart === highlightStart && c.highlightEnd === highlightEnd;
      });
      return sameConversation;
    }

    return undefined;
  },
  handleAddBodyConversation: function handleAddBodyConversation() {
    var _this$props = this.props,
        composition = _this$props.composition,
        saveState = _this$props.saveState;
    var editorState = saveState.content;
    var selection = editorState.getSelection();
    var highlightData = (0, _highlightHelpers.getHighlightDataFromEditorSelection)(editorState);

    if (highlightData === null) {
      return;
    }

    var blockKey = highlightData.blockKey,
        highlightStart = highlightData.highlightStart,
        highlightEnd = highlightData.highlightEnd;
    var block = editorState.getCurrentContent().getBlockForKey(blockKey);
    var text = block.text.slice(highlightStart, Math.min(highlightEnd, block.text.length));
    var correlationId = (0, _draftHelpers.blockKeyToCorrelationId)(blockKey);

    if (text) {
      // Check that a conversation pertaining to the same highlight doesn't already exist
      var sameConversation = this.findConversationWithSameTopic(correlationId, text, highlightStart, highlightEnd);

      if (!sameConversation) {
        this.props.createDummyConversation(correlationId, {
          objectId: composition.id,
          highlightStart: highlightStart,
          highlightEnd: highlightEnd,
          highlightText: text
        });
        var collapsedSelection = selection.merge({
          anchorKey: selection.getFocusKey(),
          anchorOffset: selection.getFocusOffset()
        });

        var updatedEditorState = _draftJs.EditorState.acceptSelection(editorState, collapsedSelection);

        this.props.updateContentToSave(updatedEditorState);
      } else {
        // Open the conversation that already exists instead of creating a new one
        this.props.selectConversationBlock(correlationId);
        this.props.openConversation(sameConversation.id);
      }
    }
  },
  handleAddPlaintextConversation: function handleAddPlaintextConversation(blockKey) {
    var _this$props2 = this.props,
        composition = _this$props2.composition,
        conversations = _this$props2.conversations;
    var correlationId = (0, _draftHelpers.blockKeyToCorrelationId)(blockKey);
    var sameConversation = conversations.blockMap.get(correlationId);

    if (!sameConversation) {
      this.props.createDummyConversation(correlationId, {
        objectId: composition.id,
        highlightStart: 0,
        highlightEnd: 0,
        highlightText: ''
      });
    } else {
      // Open the conversation that already exists instead of creating a new one
      this.props.selectConversationBlock(correlationId);
      this.props.openConversation(sameConversation.id);
    }
  },
  handleAddConversation: function handleAddConversation() {
    if (this.isOnTitleSection()) {
      this.handleAddPlaintextConversation(_constants.TITLE_BLOCK_KEY);
    } else if (this.isOnSummarySection()) {
      this.handleAddPlaintextConversation(_constants.SUMMARY_BLOCK_KEY);
    } else {
      this.handleAddBodyConversation();
    }
  },
  deleteConversation: function deleteConversation(conversation) {
    // Check if passed is a dummy id, then get real conversation id
    var idInState = conversation.id;
    var dummyConversations = this.props.conversations.dummyConversations;
    var realId = (0, _conversationsHelpers.getRealConversationId)(dummyConversations, idInState);
    var isDummy = dummyConversations.has(idInState);
    this.props.deleteConversation({
      correlationId: conversation.correlationId,
      idToDelete: realId,
      idInState: idInState,
      isDummy: isDummy,
      isEmptyConversation: !conversation.comments.size
    });
  },
  isOnTitleSection: function isOnTitleSection() {
    return this.props.conversations.showAddConversationButtonAtBlock === _constants.TITLE_BLOCK_KEY;
  },
  isOnSummarySection: function isOnSummarySection() {
    return this.props.conversations.showAddConversationButtonAtBlock === _constants.SUMMARY_BLOCK_KEY;
  },
  renderAddConversationButton: function renderAddConversationButton() {
    return _react.default.createElement(_UIButton.default, {
      className: "add-conversation",
      use: "tertiary-light",
      size: "small",
      onClick: this.handleAddConversation
    }, _react.default.createElement(_UIIcon.default, {
      name: "comments",
      className: "m-right-1"
    }), _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "composer-lib.conversations.add"
    }));
  },
  renderAddConversationButtonTether: function renderAddConversationButtonTether() {
    var blockKey = this.props.conversations.showAddConversationButtonAtBlock;

    if (!blockKey) {
      return null;
    }

    var targetNode;

    if (this.isOnTitleSection()) {
      targetNode = document.querySelector("#" + _constants.TITLE_ID);
    } else if (this.isOnSummarySection()) {
      targetNode = document.querySelector("#" + _constants.SUMMARY_ID);
    } else {
      var correlationId = (0, _draftHelpers.blockKeyToCorrelationId)(blockKey);
      targetNode = document.querySelector("[data-block=true][data-offset-key=\"" + correlationId + "\"]");
    }

    if (!targetNode) {
      return null;
    }

    return _react.default.createElement(_UIAbstractFloaty.default, {
      computePosition: computeFloatyPosition,
      content: this.renderAddConversationButton(),
      target: targetNode
    }, _react.default.createElement("div", {
      id: "add-conversation-button-tether"
    }));
  },
  render: function render() {
    var _this = this;

    var _this$props3 = this.props,
        app = _this$props3.app,
        auth = _this$props3.auth,
        conversations = _this$props3.conversations,
        users = _this$props3.users;
    var userIsAdmin = auth.user.get('scopes').contains('manage-marketing-users');
    var showAddConversationButtonAtBlock = conversations.showAddConversationButtonAtBlock;

    if (!app.loaded || conversations.status !== _constants.RequestStatus.SUCCEEDED || users.status !== _constants.RequestStatus.SUCCEEDED) {
      return null;
    }

    var conversationBlocksToRender = conversations.blockMap.filter(function (conversationList, index) {
      return (0, _draftHelpers.blockKeyToCorrelationId)(showAddConversationButtonAtBlock) !== index;
    });
    return _react.default.createElement("div", {
      className: "comments-container"
    }, conversationBlocksToRender.map(function (conversationList, index) {
      return _react.default.createElement(_ConversationsWrapper.default, {
        closeConversations: _this.props.closeConversations,
        conversations: conversationList,
        currentUserId: _this.props.auth.user.get('user_id'),
        deleteComment: _this.props.deleteComment,
        deleteCommentId: conversations.deleteCommentId,
        deleteCommentStatus: conversations.deleteCommentStatus,
        deleteConversation: _this.deleteConversation,
        deleteConversationDone: _this.props.deleteConversationDone,
        deleteConversationId: conversations.deleteConversationId,
        deleteConversationStatus: conversations.deleteConversationStatus,
        refetchUsers: _this.props.refetchUsers,
        highlightBodyText: _this.props.highlightBodyText,
        highlightSummaryText: _this.props.highlightSummaryText,
        highlightTitleText: _this.props.highlightTitleText,
        index: index,
        key: index,
        openConversation: _this.props.openConversation,
        openConversations: conversations.openConversations,
        removeHighlightedBodyText: _this.props.removeHighlightedBodyText,
        removeHighlightedSummaryText: _this.props.removeHighlightedSummaryText,
        removeHighlightedTitleText: _this.props.removeHighlightedTitleText,
        saveComment: _this.saveComment,
        selectedBlock: conversations.selectedBlock,
        selectConversationBlock: _this.props.selectConversationBlock,
        users: users,
        userIsAdmin: userIsAdmin
      });
    }).valueSeq(), this.renderAddConversationButtonTether());
  }
});

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CommentsContainer);

exports.default = _default;
module.exports = exports.default;